import React, { useEffect } from "react";
import {
  ScrollView,
  View,
  StyleSheet,
  Pressable,
} from "react-native";
import CCText from "@/Atoms/CCText";
import { useMediaQuery } from "@/Hooks/useMediaQuery/useMediaQuery";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#FAF6EB",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 40,
    paddingHorizontal: 30,
  },
  scrollView: {
    flex: 1,
  },
  wideScrollView: {
    flex: 1,
    backgroundColor: "#FAF6EB",
  },
  contentContainer: {
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 40,
    paddingHorizontal: 30,
  },
  wideContentContainer: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
  },
  wideCard: {
    width: "100%",
    maxWidth: 460,
    backgroundColor: "#fff",
    borderRadius: 20,
    paddingVertical: 36,
    paddingHorizontal: 32,
    borderWidth: 1,
    borderColor: "#E0DDD9",
    alignItems: "center",
  },
  iconPlate: {
    width: 96,
    height: 96,
    borderRadius: 26,
    backgroundColor: "#E4F6EB",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 28,
  },
  icon: {
    fontSize: 50,
  },
  redirectHint: {
    fontSize: 12.5,
    color: "#A8A7A6",
    textAlign: "center",
    marginTop: 8,
  },
  headline: {
    fontSize: 26,
    color: "#262322",
    textAlign: "center",
    marginBottom: 16,
    maxWidth: 280,
  },
  bodyText: {
    fontSize: 14,
    color: "#806234",
    lineHeight: 21.7,
    textAlign: "center",
    marginBottom: 28,
    maxWidth: 280,
  },
  primaryButton: {
    backgroundColor: "#FACF47",
    borderRadius: 999,
    paddingVertical: 15,
    paddingHorizontal: 20,
    alignItems: "center",
    marginBottom: 12,
    width: 280,
  },
  primaryButtonText: {
    color: "#4D3F37",
    fontWeight: "600",
    fontSize: 16,
  },
  secondaryButton: {
    paddingVertical: 15,
    paddingHorizontal: 20,
    alignItems: "center",
    width: 280,
  },
  secondaryButtonText: {
    color: "#888280",
    fontWeight: "600",
    fontSize: 14,
  },
});

export default function UnderReview({
  navigation,
  route,
}: {
  navigation: any;
  route: any;
}) {
  const { clubId } = route.params ?? {};
  const { isMobileOrTab } = useMediaQuery();
  const isWide = !isMobileOrTab;

  // Success screen: auto-redirect to the Clubs list after a short pause so the
  // user sees the confirmation, then lands back on their clubs.
  useEffect(() => {
    const t = setTimeout(() => navigation.navigate("Clubs"), 3000);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const content = (
    <>
      <View style={styles.iconPlate}>
        <CCText style={styles.icon}>🎉</CCText>
      </View>

      <CCText fontWeight="thunder" style={styles.headline}>
        Club created!
      </CCText>

      <CCText style={styles.bodyText}>
        Your club is live. Invite friends, chat, and climb the activity
        leaderboards together.
      </CCText>

      <Pressable
        testID="club-created-go-to-club"
        onPress={() => navigation.navigate("ClubRoom", { clubId })}
        style={styles.primaryButton}
      >
        <CCText style={styles.primaryButtonText}>
          Go to club & invite friends
        </CCText>
      </Pressable>

      <Pressable
        testID="club-created-back-to-clubs"
        onPress={() => navigation.navigate("Clubs")}
        style={styles.secondaryButton}
      >
        <CCText style={styles.secondaryButtonText}>Back to my clubs</CCText>
      </Pressable>

      <CCText style={styles.redirectHint}>
        Taking you to your clubs…
      </CCText>
    </>
  );

  if (isWide) {
    return (
      <ScrollView style={styles.wideScrollView} contentContainerStyle={styles.wideContentContainer}>
        <View style={styles.wideCard}>{content}</View>
      </ScrollView>
    );
  }

  return (
    <ScrollView style={styles.scrollView} contentContainerStyle={styles.contentContainer}>
      {content}
    </ScrollView>
  );
}
